<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-04-19 10:23:04
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-07-08 14:02:35
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\DoctorSnurses\components\ChatUserList\index.vue
-->
<template>
  <div class="chatuserlist">
    <el-scrollbar style="height: 100%" wrap-style="overflow-x:hidden;">
      <ul v-if="userDataList.length">
        <li v-for="(item, index) in userDataList" :key="index" :class="item.active ? 'avtive' : ''" @click="pushHandel(item)">
          <div class="li-content">
            <img :src="item.avatar" alt="" />
            <div class="user-left">
              <div class="left-top">
                <p>{{ item.patientName && item.patientName.length > 6 ? item.patientName.slice(0, 6) + '……' : item.patientName }}</p>
                <span>{{ item.createTime }}</span>
              </div>
              <div class="hospital-view" v-if="item.platformName">
                <p></p>
                <span>{{ item.platformName }}</span>
              </div>
              <div class="left-bottom">
                <div class="flex-view-box">
                  <div class="botton-parent name" :class="item.fontSizeColor && item.fontSizeColor == '#000' ? 'fontzSizeColor' : ''" :style="{ background: `${item.colour}` }">
                    {{ item.nursingDefinitionName }}{{ item.patientName }}
                    <div class="button-icon" v-if="untreated && item.untreated">{{ item.untreated }}</div>
                  </div>
                  <div class="botton-parent botton-ri" v-show="item.diseaseType && diseaseType">{{ item.diseaseType }}</div>
                </div>
                <!-- <p v-if="item.unreadCount">{{ item.unreadCount }}</p> -->
                <p v-if="item.unReadNumber">{{ item.unReadNumber }}</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="empty" v-else>
        <img src="../../../treatment/static/empty.png" />
      </div>
    </el-scrollbar>
  </div>
</template>
<script>
import eventBus from '@/utils/eventBus.js'
export default {
  name: 'chatUserList',
  props: {
    //聊天的用户列表
    userDataList: {
      type: Array,
      default: () => [],
    },
    //是否有倒计时
    isTime: {
      type: Boolean,
      default: false,
    },
    //过滤当前状态
    filterType: {
      type: Function,
      default: () => {
        return Function
      },
    },
    //button按钮是否有角标
    untreated: {
      type: Boolean,
      default: false,
    },
    diseaseType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editableTabsData: [],
    }
  },

  created() {
    //TODO 需要把登陆设置为全局
    // this.postimacc();
    // this.getConversationList()
    //TODO 监听删除时间
    // eventBus.$on('editableTabsRemove', (data)=>{
    //     this.editableTabsData = data;
    // });
    // //TODO 初次加载拿到聊天列表中的第一个
    // if(this.userDataList.length){
    //     setTimeout(()=>{
    //         eventBus.$emit('editableTabsData', [this.userDataList[0]])
    //     },100)
    // }
    // setTimeout(()=>{
    //     this.filterType('9')
    // },3000)
  },
  methods: {
    /**
     * @description:
     * @param {*}
     * @return {*}
     */

    pushHandel(item) {
      this.editableTabsData = this.editableTabsData.filter((sub) => sub.id != item.id)
      this.editableTabsData.unshift(item)
      this.$emit('propsUserItem', item)
    },
  },

  beforeDestroy() {
    eventBus.$off('editableTabsRemove')
  },
}
</script>
<style scoped lang="less">
.chatuserlist{
    height: 100%;
    ul{
        li{
            
            .li-content{
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px dashed #F0F0F0;
                padding-bottom: 16px;
            }
            padding: 16px 16px 0;
            cursor: pointer;
            &:active{
                background-color: #F0F0F0;
            }
            img{
                width: 54px;
                height: 54px;
                border-radius: 50%;
                object-fit: cover;
                border: 2px solid #F0F0F0;
            }
            .user-left{
                flex: 1;
                margin-left: 16px;
                .left-top {
                    margin-bottom: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    p{
                        font-weight: 500;
                        color: #333333;
                    }
                    .tiem-view{
                        width: 110px;
                        display: flex;
                        align-items: center;
                        span:first-child{
                            color: #999999;
                            margin-right: 5px;
                            display: block;
                        }
                        span:last-child{
                            font-weight: 600;
                            color: #F14352;
                        }
                    }
                    span{
                        color: #595959;
                        font-size: 12px;
                    }
                }
                .hospital-view{
                    display: flex;
                    align-items: center;
                    margin-bottom:12px;
                    p{
                        width: 6px;
                        height: 6px;
                        border-radius: 3px;
                        background: #999;
                        margin-right: 6px;
                    }
                    span{
                        flex: 1;
                        color: #595959;
                        font-size: 12px;
                        width: 215px;
                        height: auto;
                        display: block;
                        // overflow: auto;
                        // white-space: nowrap;
                    }
                }
                .left-bottom{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .flex-view-box{
                        display: flex;
                        .botton-ri{
                            background: #EFF6FF;
                            font-size: 12px;
                            color: #1A7BFC;
                            margin-left: 10px;
                        }
                    }
                    .botton-parent.name {
                      width: 200px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    }
                    .botton-parent{
                        position: relative;
                        padding: 2px 9px;
                        color: #666666;
                        font-size: 12px;
                        
                        border-radius: 11px;
                        .button-icon{
                            position: absolute;
                            right: -10px;
                            top: -10px;
                            background-color: red;
                            color: #FFFFFF;
                            border-radius: 50%;
                            font-size: 10px;
                            min-width: 16px;
                            line-height: 16px;
                            text-align: center;
                            padding: 2px;
                            box-sizing: initial;
                        }
                    }
                    .fontzSizeColor{
                        color: #000 !important;
                    }
                    
                    .black{
                        color: #000;
                    }
                    p{
                        width: 20px;
                        height: 20px;
                        background: #F14352;
                        font-size: 12px;
                        line-height: 20px;
                        border-radius: 50%;
                        text-align: center;
                        color:#fff;
                    }
                }
            }
        }
        .avtive{
            background-color: #F0F0F0;
        }
        // li:first-child{
        //     padding-top: 0 !important;
        // }
    }
    .empty{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
      
    }
}
</style>
